import React, { useState } from 'react';
import { Users, Target } from 'lucide-react';
import { ChartPie } from 'lucide-react';
import CompanyStats from '../components/stats/CompanyStats';
import RecrutementStats from '../components/stats/RecrutementStats';
import ProspectionStats from '../components/stats/ProspectionStats';
import Breadcrumb from '../components/utils/Breadcrumb';

const Analytics = () => {
  const [activeTab, setActiveTab] = useState('recrutement');

  const tabs = [
    {
      id: 'recrutement',
      label: 'Recrutement',
      icon: <Users size={18} />,
      component: <RecrutementStats />
    },
    {
      id: 'prospection',
      label: 'Prospection',
      icon: <Target size={18} />,
      component: <ProspectionStats />
    },
    {
      id: 'analytics',
      label: 'Data Vizualization',
      icon: <ChartPie size={18} />,
      component: <CompanyStats />
    }
  ];

  return (
    <div className="p-4 sm:p-6 lg:p-10 bg-gray-100 min-h-screen pt-16">
      {/* Breadcrumb */}
      <div className='pt-10'>
        <Breadcrumb items={[
        { label: 'Dashboard', href: '/app', icon: 'bi-house' },
        { label: 'Rapports', href: null, icon: 'bi-graph-up', isActive: true }
      ]} />
      </div>
      
      
      <h1 className='text-2xl sm:text-3xl font-bold mb-4 sm:mb-6'>Analytics</h1>
      {/* Barre d'onglets */}
          <div className="border-b border-slate-200 mb-4">
            <nav className="flex flex-col sm:flex-row space-y-2 sm:space-y-0 sm:space-x-4 overflow-x-auto" aria-label="Tabs">
              {tabs.map((tab) => (
                <button
                  key={tab.id}
                  onClick={() => setActiveTab(tab.id)}
                  className={`
                    flex items-center justify-center sm:justify-start space-x-2 py-2 px-3 sm:px-1 border-b-2 font-medium text-sm transition-colors whitespace-nowrap
                    ${activeTab === tab.id
                      ? 'border-indigo-500 text-indigo-600'
                      : 'border-transparent text-slate-500 hover:text-slate-700 hover:border-slate-300'
                    }
                  `}
                >
                  {tab.icon}
                  <span className="hidden sm:inline">{tab.label}</span>
                  <span className="sm:hidden">{tab.label.split(' ')[0]}</span>
                </button>
              ))}
            </nav>
          </div>

          {/* Contenu des onglets */}
          <div className="w-full overflow-x-auto">
            {tabs.find(tab => tab.id === activeTab)?.component}
          </div>
    </div>
  );
};

export default Analytics;